import { css } from 'styled-components';

export const container = css`
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
`;
